export default __webpack_public_path__ + "static/media/Servatus.c83a09b3.jpg";